export const tableStyles = {
  panel: 'flex flex-col gap-4',
  filledPanel: '-mt-4 min-h-0 flex-1 border-l border-brand-neutral-200 bg-brand-neutral-50 p-4',
  filledContainer: 'min-h-0 !max-h-none flex-1',
  pagination: 'flex shrink-0 items-center justify-center gap-3',
  container: 'overflow-auto rounded-md border border-brand-neutral-200 bg-white max-h-[65vh]',
  table: 'table-fixed border-separate border-spacing-0 text-sm',
  head: 'sticky top-0 z-10 bg-brand-neutral-50',
  headerCell: 'relative border-b border-r border-brand-neutral-200 bg-brand-neutral-50 text-left align-middle font-medium',
  cellBorder: 'border-b border-r border-brand-neutral-200',
  cellFocus:
    'has-[[data-table-copy-content]:focus,[data-table-cell-scroll]:focus]:outline has-[[data-table-copy-content]:focus,[data-table-cell-scroll]:focus]:outline-2 has-[[data-table-copy-content]:focus,[data-table-cell-scroll]:focus]:-outline-offset-2 has-[[data-table-copy-content]:focus,[data-table-cell-scroll]:focus]:outline-brand-500 has-[.table-cell-editor]:!outline-none',
  cellBackground: 'bg-white',
  cellPadding: 'px-4 py-3',
  selectionCell: 'border-b border-r border-brand-neutral-200 bg-white pt-1 text-center align-top',
  deleteCell: 'border-b border-r border-brand-neutral-200 bg-white text-center align-middle',
}
